import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AttributesApiService} from '../attributes/attributes-api.service';
import {GroupsApiService} from '../groups/groups-api.service';
import {
  addDictionaryAttributesAsProperties, removeUsersCombinedAttributes,
  removeUsersNonLocalAttributes,
  restructureFilterParams
} from '../userUtility';
import {UrlQueryService} from '../../../common/url-query/url-query.service';
import {map} from 'rxjs/operators';
import {FileSaverService} from 'ngx-filesaver';
import {UserType} from '../enums/user-type.enum';
import {ServersApiService} from '../servers/servers-api.service';
import {FileRepositoryApiService} from '../file-repository/file-repository-api.service';


@Injectable({
  providedIn: 'root'
})
export class UsersApiService {

  constructor(private http: HttpClient,
              private attributesApiService: AttributesApiService,
              private groupsApiService: GroupsApiService,
              private fileSaverService: FileSaverService,
              private serversApiService: ServersApiService,
              private fileRepositoryApiService: FileRepositoryApiService) {
  }

  readonly usersUrl: string = 'identity/user';

  public getUsers(params): Promise<any> {
    restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(this.usersUrl, params);
    return this.http.get(url).pipe(
      map((value: any) => {
        value.users.forEach((user) => {
          addDictionaryAttributesAsProperties(user);
        });

        return value;
      })
    ).toPromise();
  }

  public getUser(id): Promise<any> {
    const url = this.usersUrl + '/' + id;
    return this.http.get(url).toPromise();
  }

  public addUser(user): Promise<any> {
    removeUsersCombinedAttributes(user);
    return this.http.post(this.usersUrl, user).toPromise();
  }

  public editUser(user): Promise<any> {
    const url = this.usersUrl + '/' + user.id;
    removeUsersNonLocalAttributes(user);
    return this.http.put(url, user).toPromise();
  }

  deleteUsers(ids): Promise<any> {
    const url = UrlQueryService.addQueryParameters(this.usersUrl, {filter: {id: {value: ids, operator: '='}}});
    return this.http.delete(url).toPromise();
  }

  public getUsersCount(): Promise<any> {
    return this.http.get(`${this.usersUrl}/count`).toPromise();
  }

  public prepareDataForUserEdit(userId: number): Promise<any> {
    const data: any = {};
    return this.getUser(userId)
      .then((user) => {
        data.user = user;
        return this.groupsApiService.getGroupsNames(user.groups);
      })
      .then((groupNames) => {
        data.groupNames = groupNames;
        return data;
      });
  }

  public prepareDataForNewUser(): Promise<any> {
    const newUser: any = {
      name: '',
      origin: 'ARM',
      groups: []
    };

    return this.attributesApiService.getAttributes()
      .then(
        (attrs: any[]) => {
          newUser.dicAttributes = attrs.map((attr) => {
            return {
              dicAttrId: attr.id,
              dicAttrName: attr.name,
              value: '',
              local: true,
              isCombined: attr.isCombined
            };
          });
          return newUser;
        }
      )
      .catch((err) => {
      });
  }

  public generateOriginOptions(): Promise<any> {
    return Promise.all([
      this.serversApiService.getServers(),
      this.fileRepositoryApiService.getFileRepositories()
    ]).then(data => {
      return this.prepareOriginData(data[0], data[1]);
    }).catch(err => {});
  }

  public exportUsersToCsv(params): void {
    restructureFilterParams(params);
    const url = UrlQueryService.addQueryParameters(`${this.usersUrl}/export`, params);

    this.http.get(url, { responseType: 'blob' }).subscribe(data => {
      const fileType = {type: 'text/csv'};
      const blob = new Blob([ data ], fileType);
      this.fileSaverService.save(blob, 'Users.csv');
    });
  }

  private prepareOriginData(servers, fileRepositories): any {
    // const originOptions = [];
    //
    // const serversOptions = servers.map(ldap => {
    //   return {
    //     value: {
    //       id: ldap.id,
    //       name: ldap.name,
    //       type: UserType.LDAP_SERVER
    //     },
    //     text: ldap.name
    //   };
    // });
    //
    // const fileRepositoriesOptions = fileRepositories.elements.map(fileRepository => {
    //   return {
    //     value: {
    //       id: fileRepository.id,
    //       name: fileRepository.name,
    //       type: UserType.FILE_REPOSITORY
    //     },
    //     text: fileRepository.name
    //   };
    // });
    //
    // originOptions.push({
    //   name: UserType.LOCAL,
    //   items: [
    //     {
    //       value: {
    //         id: -1,
    //         name: 'ARM',
    //         type: UserType.LOCAL
    //       },
    //       text: 'ARM'
    //     }
    //   ]
    // });
    //
    // if (serversOptions && serversOptions.length) {
    //   originOptions.push({
    //     name: UserType.LDAP_SERVER,
    //     items: serversOptions
    //   });
    // }
    //
    // if (fileRepositoriesOptions && fileRepositoriesOptions.length) {
    //   originOptions.push({
    //     name: UserType.FILE_REPOSITORY,
    //     items: fileRepositoriesOptions
    //   });
    // }
    //
    // return originOptions;

    const originOptions = [];
    servers.forEach(ldap => {
      originOptions.push({text: ldap.name, value: ldap.id, type: UserType.LDAP_SERVER});
    });
    fileRepositories.elements.forEach(fileRepository => {
      originOptions.push({text: fileRepository.name, value: fileRepository.id, type: UserType.FILE_REPOSITORY});
    });
    originOptions.push({value: -1, text: 'ARM', type: UserType.LOCAL});

    return originOptions;

  }
}
